"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRegionMatching = void 0;
const countries_1 = require("../countries");
const parse_1 = require("./ie/parse");
const parse_2 = require("./gb/parse");
function getRegionMatching(country, input) {
    if (country.code === countries_1.COUNTRY_BY_CODE.GB.code) {
        return (0, parse_2.getRegionMatching)(input);
    }
    else if (country.code === countries_1.COUNTRY_BY_CODE.IE.code) {
        return (0, parse_1.getRegionMatching)(input);
    }
    else {
        return undefined;
    }
}
exports.getRegionMatching = getRegionMatching;
